module.exports = __webpack_public_path__ + "static/media/history_14.e0c2e7ab.jpg";